jQuery(document).ready(function ($) {
    let lastSelectedDate = null;

    function resetLoadMoreButton() {
        const button = $('#load-more-events');
        button.data('page', 2);
        button.data('last-month', '');
        button.show();
        button.text('Load More').prop('disabled', false);
    }

    function hideDuplicateMonthSeparators() {
        const existingMonths = new Set();
        $('.tribe-events-calendar-list__month-separator').each(function () {
            const datetimeValue = $(this).find('time').attr('datetime');
            if (existingMonths.has(datetimeValue)) {
                $(this).hide();
            } else {
                existingMonths.add(datetimeValue);
            }
        });
    }

    function toggleLoadMoreButton() {
        const hasEvents = $('.tribe-events-calendar-list').children().length > 0;
        if (!hasEvents) {
            $('#load-more-events').hide();
        } else {
            $('#load-more-events').show();
        }
    }

    // when date changes clear list and reset page & last-month
    $(document).on('change', '#tribe-events-top-bar-date', function () {
        const startDate = $(this).val();
        if (startDate !== lastSelectedDate) {
            lastSelectedDate = startDate;
            $('.tribe-events-calendar-list').empty();
            resetLoadMoreButton();
            toggleLoadMoreButton();
            loadEvents(startDate, 1);
        }
    });

    $(document).on('click', '.tribe-events-c-top-bar__today-button', function (e) {
        e.preventDefault();
        const todayDate = $('#tribe-events-top-bar-date').val();
        if (todayDate !== lastSelectedDate) {
            lastSelectedDate = todayDate;
            $('.tribe-events-calendar-list').empty();
            resetLoadMoreButton();
            toggleLoadMoreButton();
            loadEvents(todayDate, 1);
        }
    });

    function loadEvents(startDate, page) {
        const button = $('#load-more-events');
        const nonce = ajaxLoadMore.nonce;
        const lastRenderedMonth = button.data('last-month') || '';

        $.ajax({
            url: ajaxLoadMore.ajaxUrl,
            type: 'POST',
            data: {
                action: 'load_more_events',
                page: page,
                nonce: nonce,
                last_month: lastRenderedMonth,
                start_date: startDate,
            },
            beforeSend: function () {
                button.prop('disabled', true).text('Loading...');
            },
            success: function (response) {
                if (response.success) {
                    $('.tribe-events-calendar-list').append(response.data.html);
                    hideDuplicateMonthSeparators();
                    toggleLoadMoreButton();
                    button.data('page', page + 1);
                    button.data('last-month', response.data.last_month);
                    button.text('Load More').prop('disabled', false);
                } else {
                    button.fadeOut(300, function () {
                        $(this).remove();
                    });
                }
            },
            error: function () {
                button.text('Error, try again').prop('disabled', false);
            },
        });
    }

    // Load more button click triggers loading next page with current date
    $('#load-more-events').on('click', function () {
        const button = $(this);
        let page = button.data('page');
        if (!page) {
            page = 2; // page 1 was rendered initially
        }
        const startDate = $('#tribe-events-top-bar-date').val();
        loadEvents(startDate, page);
    });

    // Initial page load setup
    toggleLoadMoreButton();
});
